var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel-container show" }, [
    _c("div", { staticClass: "panel-content" }, [
      _c(
        "div",
        {
          staticClass:
            "d-flex flex-column align-items-center justify-content-center p-4",
        },
        [
          this.location.id > 0
            ? _c("h5", { staticClass: "mb-0 fw-700 text-center mt-3" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(this.location.title) +
                    "\n                "
                ),
              ])
            : _c("h5", { staticClass: "mb-0 fw-700 text-center mt-3" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.__t("NEW_REST")) +
                    "\n                "
                ),
              ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("div", { staticClass: "form-group mt-2" }, [
            _c(
              "label",
              { staticClass: "form-label", attrs: { for: "advanced_name" } },
              [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.__t("REST_NAME")) +
                    "\n                    "
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "input-group flex-nowrap" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.location.title,
                    expression: "location.title",
                  },
                ],
                staticClass: "form-control",
                attrs: { id: "advanced_name", type: "text" },
                domProps: { value: _vm.location.title },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.location, "title", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "panel-tag mt-2" }, [
            _vm._v(
              "\n                    " +
                _vm._s(_vm.__t("POS_PARAMS")) +
                "\n                "
            ),
          ]),
          _vm._v(" "),
          _c("location_general_params", { attrs: { location: _vm.location } }),
          _vm._v(" "),
          _c("div", { staticClass: "panel-tag mt-2" }, [
            _vm._v(
              "\n                    " +
                _vm._s(_vm.__t("PWA_LOCATION_PARAMS")) +
                "\n                "
            ),
          ]),
          _vm._v(" "),
          _c(
            "b-tabs",
            { attrs: { "content-class": "mt-3 mb-4" } },
            _vm._l(_vm.tabs, function (tab, index) {
              return _c(
                "b-tab",
                {
                  key: index,
                  attrs: {
                    title: _vm.get_tab_title(tab),
                    active: tab.is_active,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.set_active(index)
                    },
                  },
                },
                [
                  _c(
                    "template",
                    { slot: "title" },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.get_tab_title(tab)) +
                          "\n                            "
                      ),
                      tab.is_load
                        ? _c("b-spinner", {
                            attrs: { type: "grow", small: "" },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  tab.index == "pwa_main_settings"
                    ? _c(
                        "div",
                        { staticClass: "general_pwa_settings" },
                        _vm._l(_vm.general_fields, function (general_field) {
                          return _c("div", { staticClass: "form-group mt-2" }, [
                            _c("label", { staticClass: "form-label" }, [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(general_field.title) +
                                  "\n                                "
                              ),
                            ]),
                            _vm._v(" "),
                            !(
                              _vm.is_bool_field(general_field) ||
                              _vm.is_editor(general_field)
                            )
                              ? _c(
                                  "div",
                                  { staticClass: "input-group flex-nowrap" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "input-group-prepend" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "input-group-text" },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fal fa-typewriter fs-xl",
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.location.general_fields[
                                              general_field.key
                                            ],
                                          expression:
                                            "location.general_fields[general_field.key]",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        id: general_field.key,
                                        type: "text",
                                      },
                                      domProps: {
                                        value:
                                          _vm.location.general_fields[
                                            general_field.key
                                          ],
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.location.general_fields,
                                            general_field.key,
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.is_bool_field(general_field)
                              ? _c(
                                  "div",
                                  { staticClass: "input-group flex-nowrap" },
                                  [
                                    _c("b-form-radio-group", {
                                      attrs: {
                                        id: "btn-radios-" + general_field.key,
                                        "button-variant": "outline-primary",
                                        options: [
                                          { text: "YES", value: true },
                                          { text: "NO", value: false },
                                        ],
                                        name: "btn-radios-" + general_field.key,
                                        buttons: "",
                                      },
                                      model: {
                                        value:
                                          _vm.location.general_fields[
                                            general_field.key
                                          ],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.location.general_fields,
                                            general_field.key,
                                            $$v
                                          )
                                        },
                                        expression:
                                          "location.general_fields[general_field.key]",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.is_editor(general_field)
                              ? _c(
                                  "div",
                                  { staticClass: "editor" },
                                  [
                                    _c("vue-editor", {
                                      attrs: {
                                        "editor-toolbar": _vm.editor_rules,
                                      },
                                      model: {
                                        value:
                                          _vm.location.general_fields[
                                            general_field.key
                                          ],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.location.general_fields,
                                            general_field.key,
                                            $$v
                                          )
                                        },
                                        expression:
                                          "location.general_fields[general_field.key]",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ])
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  tab.index == "pwa_shipment_settings"
                    ? _c(
                        "div",
                        { staticClass: "general_pwa_settings" },
                        [
                          _c("pwa_shipment_settings", {
                            attrs: { location: _vm.location },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                2
              )
            }),
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }